import { Button, Flex, Spinner, Text } from "@chakra-ui/react";
import { SavedSetups } from "api/generated/graphql";
import { IconCheckGreen, IconPencil, IconTrashCan } from "icons";

interface SavedSetupProps {   
  isSelected: boolean;
  savedSetup: SavedSetups;
  lastUsed: boolean;
  onDelete: (savedSetupId: string) => void;
  isLoadingRemove?: boolean;
  handleSelectSavedSetup?: (savedSetup: SavedSetups) => void;
  isApplyingSavedSetup?: boolean;
}

const SavedSetup = ({ isSelected, savedSetup, lastUsed, onDelete, isLoadingRemove, handleSelectSavedSetup, isApplyingSavedSetup }: SavedSetupProps) => {
  return (
    <Flex
      background={
        isSelected 
        ? 'linear-gradient(90deg, rgba(79, 197, 186, 0.1) 0%, rgba(79, 197, 186, 0) 100%)'
        : 'linear-gradient(90deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0) 100%)' 
      }
      borderRadius="4px"
      p="3"
      position="relative"
      alignItems="center"
      w="full"
      justifyContent="space-between"
      _before={{
        content: '""',
        position: 'absolute',
        inset: 0,
        borderRadius: '4px',
        padding: '2px',
        background: isSelected 
        ? 'linear-gradient(90deg, rgba(79, 197, 186, 0.4) 0%, rgba(79, 197, 186, 0) 100%)' 
        : 'linear-gradient(90deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%)',
        mask: "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
        maskComposite: "exclude",
      }}
    >
      <Flex
        alignItems="center"
        gap="2"
      >
        {!lastUsed && (
          <Flex
            background="linear-gradient(225deg, rgba(255, 53, 57, 0.2) 0%, rgba(216, 56, 50, 0.2) 18%, rgba(216, 56, 50, 0.2) 73%, rgba(173, 53, 41, 0.2) 100%)"
            borderRadius="4px"
            px="3"
            py="2"
            position="relative"
            cursor="pointer"
            _hover={{
              background: 'linear-gradient(360deg, rgba(255, 53, 57, 0.3) 0%, rgba(255, 53, 57, 0.24) 100%)',
            }}
            _before={{
              content: '""',
              position: 'absolute',
              inset: 0,
              borderRadius: '4px',
              padding: '2px',
              background: 'linear-gradient(360deg, rgba(255, 53, 57, 0.6) 0%, rgba(255, 53, 57, 0.24) 100%)',
              mask: "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
              maskComposite: "exclude",
            }}
            onClick={() => onDelete(savedSetup.id as string)}
          >
            {isLoadingRemove ? (
              <Spinner size="sm" />
            ) : (
              <IconTrashCan 
                __css={{
                  path: {
                    fill: 'rgba(255, 0, 4, 0.8)',
                  }
                }}
              />
            )}
          </Flex>
        )}

        <Text
          fontSize={{ base: '12px', md: '14px' }}
          lineHeight={{ base: '14px', md: '18px' }}
          fontWeight={500}
          color={isSelected ? 'white.95' : 'white.60'}
        >
          {savedSetup?.name}
        </Text>

        {/* {!lastUsed && (
          <IconPencil 
            cursor="pointer"
            __css={{
              path: {
                fill: 'rgba(255, 255, 255, 0.6)',
                _hover: {
                  fill: 'rgba(255, 255, 255, 0.8)',
                },
                transition: 'fill 0.2s ease-in-out',
              }
            }}
          />
        )} */}
      </Flex>

      <Flex>
        {(isSelected && !isApplyingSavedSetup) ? (
          <IconCheckGreen />
        ) : (
          <Button
            variant="upgrade-button"
            onClick={() => handleSelectSavedSetup?.(savedSetup)}
            color="rgba(53, 255, 236, 0.8)"
            fontSize="10.5px"
            lineHeight="14px"
            h="22px"
            isLoading={isApplyingSavedSetup}
          >
            Apply
          </Button>
        )}
      </Flex>
    </Flex>
  );
};

export default SavedSetup;